import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	selector: "app-custom-detention1",
	templateUrl: "./custom-detention1.component.html",
	styleUrls: ["./custom-detention1.component.css"],
})
export class CustomDetention1Component implements OnInit {
	constructor(private selectService: SchoolselectorService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		StartDate: new Date(),
		EndDate: new Date(),
		InfractionID: 0,
		GradeLevelID: 0,
		ContinueAlertID: -1,
		SortOrderID: "ASC",
		OrderBy: "Date",
		// ImageLogo: 0,
	};

	//Insert Custom Lists Here
	InfractionList: any = [];
	GradeLevelList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ContinueAlertList: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Incident Has Alert",
		},
		{
			ID: 0,
			Desc: "Alert Turned Off",
		},
	];
	OrderByList: any = [
		{
			ID: "Date",
			Desc: "Date/Time",
		},
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "Infraction",
			Desc: "Infraction",
		},
		{
			ID: "StudentID",
			Desc: "Student ID",
		},
		{
			ID: "Grade",
			Desc: "Grade",
		},
		{
			ID: "School",
			Desc: "School Number",
		},
	];
	SortOrderList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 438;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadDistrictSchoolList()
		// this.loadActionTypeList()
		// this.loadInfractionList()
		// this.loadSchoolGroupList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadInfractionList();
		this.loadGradeLevelList();
		// this.loadLogolist();
	}

	private loadInfractionList() {
		this.report.InfractionID = 0;
		var result = this.reportService.InfractionGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InfractionList = response;

				// this.InfractionList.unshift({
				//     InfractionID: 0,
				//     InfractionDesc: "All Infractions"
				// });

				this.report.InfractionID = this.InfractionList[0].InfractionID;
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				// this.GradeLevelList.unshift({
				//   GradeLevelID: 0,
				//   GradeLevelDesc: "All Grades"
				// });

				this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	// private loadLogolist() {
	//     var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
	//     result.subscribe(
	//         response => {
	//             this.ImageLogoList = response;

	//             this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;

	//         },
	//         error => {
	//         }
	//     )

	// }

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.DistrictSchoolID) {
		// 	this.errorMessage = "Select the DistrictSchool"
		// 	return;
		// }

		if (!this.report.StartDate) {
			this.errorMessage = "Select the Start Date/Time";
			return;
		}

		if (!this.report.EndDate) {
			this.errorMessage = "Select the End Date/Time";
			return;
		}

		// if (!this.report.InfractionID) {
		// 	this.errorMessage = "Select the Infraction"
		// 	return;
		// }

		// if (!this.report.SchoolGroupID) {
		// 	this.errorMessage = "Select the SchoolGroup"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 438;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: StartDT
		strParam += moment(this.report.StartDate).format("MM/DD/YYYY HH:mm:00") + "|StartDT";

		//Parameter 2: EndDT
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY HH:mm:00") + "|EndDT";

		//Parameter 3: InfractionID
		strParam += "," + this.report.InfractionID + "|InfractionID";

		//Parameter 4: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 5: ContinueAlertID
		strParam += "," + this.report.ContinueAlertID + "|ContinueAlert";

		//Parameter 6: OrderBy
		strParam += "," + this.report.OrderBy + "|OrderBy";

		//Parameter 7: SortOrder
		strParam += "," + this.report.SortOrderID + "|SortOrder";

		// //Parameter 8: ImageLogo
		// strParam += "," + this.report.ImageLogo + "|Imagelogo"

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
